module.exports = __webpack_public_path__ + "img/pro_capture9.620c4877.png";